// ============================================================
// ModalConsultaIncompleta
// ------------------------------------------------------------
// Modal bloqueante que se muestra cuando NOM-024 está activa
// y faltan datos obligatorios antes de guardar la consulta.
// ============================================================

import React from "react";
import "./ModalEdicion.css";

const ModalConsultaIncompleta = ({ faltantes, onClose, tipo = "historia" }) => {
  if (!faltantes || faltantes.length === 0) return null;

  const titulo =
    tipo === "historia"
      ? "⚠️ Historia clínica incompleta"
      : "⚠️ Consulta incompleta";

  const texto =
    tipo === "historia"
      ? "Antes de guardar, completa los siguientes datos obligatorios:"
      : "Antes de guardar, completa los siguientes datos obligatorios:";

  return (
    <div className="modal-overlay modal-perfil-overlay">
      <div className="modal-content modal-perfil">
        <h3>{titulo}</h3>

        <p>{texto}</p>

        <ul className="modal-perfil-lista">
          {faltantes.map((campo, i) => (
            <li key={i}>❌ {campo}</li>
          ))}
        </ul>

        <div className="modal-buttons">
          <button
            type="button"
            className="btn-guardar"
            onClick={onClose}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConsultaIncompleta;